import { useQueryClient, useQuery } from '@tanstack/react-query';
import { useRef, useCallback } from 'react';
import { getClassesQuery, getStudentsInClassesQuery } from '@pm2/api';
import { useNavigationManager } from '@provider/navigation';
import { useUserIdentityState } from '@provider/user-identity';
import { prefetchQueryIfNeeded } from '@utils/common';
import { ShareSelect } from './atom.select.js';
import { jsx } from 'react/jsx-runtime';

function ClassPage(props) {
  const fallbackClasses = useRef(props.selectedClasses);
  const queryClient = useQueryClient();
  const navigation = useNavigationManager();
  const user = useUserIdentityState(state => state.user);
  const classes = useQuery(getClassesQuery.useQueryConfig());
  const selectedValues = props.selectedClasses.map(it => ({
    id: it.id,
    label: it.name
  }));
  const options = classes.data?.map(className => ({
    id: className.id,
    label: className.name
  })) ?? [];
  const toggleValue = useCallback(value => {
    const toggledClass = classes.data?.find(it => it.id === value);
    if (!toggledClass) {
      return;
    }

    // Reset selected students if changing classes as the list of students
    // are directly dependent on the classes selected.
    props.setSelectedStudents([]);
    props.setSelectedClasses(prev => {
      const set = new Set(prev);
      if (set.has(toggledClass)) {
        set.delete(toggledClass);
      } else {
        set.add(toggledClass);
      }
      return [...set];
    });
  }, [classes.data, props]);
  const handleCancel = useCallback(() => {
    props.setSelectedClasses(fallbackClasses.current);
    navigation.push("/");
  }, [navigation, props]);
  const handleSave = useCallback(async () => {
    await prefetchQueryIfNeeded(queryClient, getStudentsInClassesQuery(user, props.selectedClasses.map(it => it.id)));
    navigation.push("/");
  }, [navigation, props.selectedClasses, queryClient, user]);
  return /*#__PURE__*/jsx(ShareSelect, {
    requiredLabel: "V\xE6lg den klasse du vil dele versionen med",
    label: "V\xE6lg klasse",
    inputPlaceholder: "S\xF8g efter hold",
    selectedValues: selectedValues.map(it => it.id),
    options: options,
    toggleValue: toggleValue,
    onSave: handleSave,
    onCancel: handleCancel,
    required: true
  });
}

export { ClassPage };
//# sourceMappingURL=page.class.js.map
